// Kleurbolletjes op de productkaart (blocks/mv-kleuren.liquid): klik = de foto van die kleur in dezelfde kaart,
// zoals op monavida.nl. Eén luisteraar op het document, zodat ook kaarten die later laden (filters, paginering) werken.
if (!window.__mvKleuren) {
  window.__mvKleuren = true;
  document.addEventListener('click', (event) => {
    const bol = event.target.closest('.mv-kleuren__bol');
    if (!bol) return;
    event.preventDefault();
    const groep = bol.closest('[data-mv-kleuren]');
    groep?.querySelectorAll('.mv-kleuren__bol').forEach((b) => {
      const gekozen = b === bol;
      b.classList.toggle('is-gekozen', gekozen);
      b.setAttribute('aria-pressed', String(gekozen));
    });
    const srcset = bol.dataset.srcset;
    const kaart = bol.closest('product-card, .product-card');
    const img = kaart?.querySelector('.card-gallery img');
    if (!srcset || !img) return;
    img.srcset = srcset;
    img.src = srcset.split(', ').at(-1).split(' ')[0];
  });
}
